import { pill } from "@/lib/permissions";

export function StatusPill({ status, className = "", size = "sm" }) {
    const p = pill(status);
    return (
        <span
            data-testid={`status-pill-${status}`}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${p.cls} ${className}`}
        >
            {p.label}
        </span>
    );
}
